<!-- Botão visível apenas em telas pequenas -->

<div class="container-btn-sidebar">
	<p-button
		[styleClass]="
			isMobileSidebarOpen
				? 'fa-solid fa-angles-right p-button-text p-button-sm btn-sidebar'
				: 'fa-solid fa-angles-left p-button-text p-button-sm btn-sidebar'
		"
		pTooltip="Menu"
		(click)="toggleMobileSidebar()"
	>
	</p-button>
</div>

<!-- Sidebar -->

<aside
	#sidebar
	[class.mobile-visible]="isMobileSidebarOpen"
	[class.mobile]="isMobile"
	[class.hidden]="isMobile && !isMobileSidebarOpen"
	[class.show-labels]="isMobile"
	class="sidebar"
>
	<ul>
		<ng-container *ngFor="let item of menuItems">
			<li
				*ngIf="shouldDisplay(item)"
				pTooltip="{{ item.label }}"
				tooltipPosition="right"
				[routerLink]="item.route"
				routerLinkActive="active"
				[routerLinkActiveOptions]="item.activeOptions || { exact: false }"
				[ngClass]="{
					active: isActive(item),
					'disabled-feature': item.feature && !hasFeature(item.feature)
				}"
				(click)="item.action ? item.action($event) : null"
				(mouseenter)="hoveredItem = item"
				(mouseleave)="hoveredItem = null"
			>
				<span class="icon-item">
					<i class="{{ item.icon }}"></i>

					<!-- Badge do carrinho -->
					<i
						class="i-cart"
						*ngIf="item.label === 'Carrinho' && cartTotalItems > 0"
						pBadge
						[value]="cartTotalItems.toFixed(stockDecimalPlaces)"
					></i>

					<!-- Selo PRO (quando a feature não está habilitada) -->

					<p-badge
						class="pro-badge"
						*ngIf="item.feature && !hasFeature(item.feature)"
						value="PRO"
					></p-badge>

					<small
						class="menu-label"
						*ngIf="isActive(item) || hoveredItem === item || isMobile"
					>
						{{ item.label }}
					</small>
				</span>
			</li>
		</ng-container>
	</ul>
</aside>

<p-menu
	styleClass="p-menu-config"
	#settingsMenu
	[popup]="true"
	[model]="settingsMenuItems"
	[baseZIndex]="10010"
	[autoZIndex]="true"
	appendTo="body"
	(onHide)="onSettingsMenuHide()"
></p-menu>
